import React, { useContext } from 'react';
import flush from 'just-flush';
import { ServiceItemsGrid } from '@stereoagency/ui';
import { useQuery } from 'urql';
import useTranslation from 'next-translate/useTranslation';
import { FindAllServiceSummariesByIdsQueryDocument } from '@/gql/client/graphql';
import { useFragment } from '@/gql';
import { ServiceSummaryFieldsFragment } from '@/gql/documents/fragments';
import { LinesContext } from '@/components/LinesContext';

type Props = {
  data: {
    title: string
    services: number[]
  }
};

export default function NvisoCertifications({ data: { title, services } }: Props) {
  const { enableLines } = useContext(LinesContext);
  const { t } = useTranslation();
  const [{ data: servicesQueryResult }] = useQuery({
    query: FindAllServiceSummariesByIdsQueryDocument,
    variables: { ids: services.map((id) => String(id)).sort() },
  });
  const servicesFields = useFragment(ServiceSummaryFieldsFragment, servicesQueryResult?.services?.nodes);

  return (
    <ServiceItemsGrid
      enableLines={enableLines}
      title={title}
      cards={flush(services.map((id) => {
        const serviceObject = servicesFields?.find((entry) => (
          entry.databaseId === id
        ));
        if (serviceObject?.title) {
          return {
            title: serviceObject.title,
            callToAction: {
              label: t('global:read-more'),
              href: serviceObject.uri ?? '/',
            },
          };
        }
        return null;
      }))}
    />
  );
}
